import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=2772ac28&scoped=true"
import script from "./grid-item.vue?vue&type=script&lang=js"
export * from "./grid-item.vue?vue&type=script&lang=js"
import style0 from "./grid-item.vue?vue&type=style&index=0&id=2772ac28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772ac28",
  null
  
)

export default component.exports